<getty-images
    [window]="true">
</getty-images>